import { ApiService } from './api';
import { ApiResponse } from '../types/auth';
import {
  AutoAcceptRule,
  CreateAutoAcceptRuleRequest,
  UpdateAutoAcceptRuleRequest,
  BulkUpdatePrioritiesRequest,
} from '../types/autoAcceptRules';

export class AutoAcceptRulesService {
  private apiService: ApiService;

  constructor() {
    this.apiService = ApiService.getInstance();
  }

  async getAllRules(): Promise<ApiResponse<AutoAcceptRule[]>> {
    try {
      const response = await this.apiService.get<AutoAcceptRule[]>('/admin/auto-accept-rules');
      return {
        data: response,
        success: true
      };
    } catch (error) {
      return {
        error: error instanceof Error ? error.message : 'Failed to fetch auto-accept rules',
        success: false
      };
    }
  }

  async getRule(ruleId: number): Promise<ApiResponse<AutoAcceptRule>> {
    try {
      const response = await this.apiService.get<AutoAcceptRule>(`/admin/auto-accept-rules/${ruleId}`);
      return {
        data: response,
        success: true
      };
    } catch (error) {
      return {
        error: error instanceof Error ? error.message : 'Failed to fetch rule',
        success: false
      };
    }
  }

  async createRule(request: CreateAutoAcceptRuleRequest): Promise<ApiResponse<AutoAcceptRule>> {
    try {
      const response = await this.apiService.post<AutoAcceptRule>('/admin/auto-accept-rules', request);
      return {
        data: response,
        success: true
      };
    } catch (error) {
      return {
        error: error instanceof Error ? error.message : 'Failed to create rule',
        success: false
      };
    }
  }

  async updateRule(request: UpdateAutoAcceptRuleRequest): Promise<ApiResponse<AutoAcceptRule>> {
    try {
      const response = await this.apiService.put<AutoAcceptRule>('/admin/auto-accept-rules', request);
      return {
        data: response,
        success: true
      };
    } catch (error) {
      return {
        error: error instanceof Error ? error.message : 'Failed to update rule',
        success: false
      };
    }
  }

  async deleteRule(ruleId: number): Promise<ApiResponse<void>> {
    try {
      await this.apiService.delete(`/admin/auto-accept-rules/${ruleId}`);
      return {
        success: true
      };
    } catch (error) {
      return {
        error: error instanceof Error ? error.message : 'Failed to delete rule',
        success: false
      };
    }
  }

  async bulkUpdatePriorities(request: BulkUpdatePrioritiesRequest): Promise<ApiResponse<void>> {
    try {
      await this.apiService.put<void>('/admin/auto-accept-rules/priorities', request);
      return {
        success: true
      };
    } catch (error) {
      return {
        error: error instanceof Error ? error.message : 'Failed to update priorities',
        success: false
      };
    }
  }
}

export const autoAcceptRulesService = new AutoAcceptRulesService();
